import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HRLayout from './HRLayout';
const HRDashboard = lazy(() => import('./HRDashboard')); // V71.39 — recharts ana pakete girmesin (Suspense içinde)
import HRProfile from './HRProfile';
import HRTeam from './HRTeam';
import HRComingSoon from './HRComingSoon';
import HRPayslips from './HRPayslips'; // V70.159 — 'Yakında' stub'ı kalktı

// Mevcut HR sayfalarını /HR/ altında da kullan (lazy load)
const HRLeaves = lazy(() => import('../HRLeaves'));
const HRAdvances = lazy(() => import('../HRAdvances'));
const HRExpenses = lazy(() => import('../HRExpenses'));
const HRTrainings = lazy(() => import('../HRTrainings'));
// V70.48 — İK süiti komple portalda: ana sidebar'daki İK kategorisi kaldırıldı,
// yönetim sayfaları da portal menüsünden (yalnız hr_performance yetkisiyle) erişilir
const HRShifts = lazy(() => import('../HRShifts'));
const HRTimesheet = lazy(() => import('../HRTimesheet'));
const HROvertime = lazy(() => import('../HROvertime'));
const HRCompliance = lazy(() => import('../HRCompliance'));
const HRSalary = lazy(() => import('../HRSalary'));
const HRPayroll = lazy(() => import('../HRPayroll'));
const HROrgChart = lazy(() => import('../HROrgChart'));
const HREvalCycles = lazy(() => import('../HREvalCycles'));
const HREvalMyTasks = lazy(() => import('../HREvalMyTasks'));
const WeeklyDuty = lazy(() => import('../WeeklyDuty'));
const HRRemoteWork = lazy(() => import('../HRRemoteWork')); // V71.3.1 — Evden Çalışma
const HRDefinitions = lazy(() => import('../HRDefinitions')); // V70.53 — izin/limit tanımları
const HRStaffDetail = lazy(() => import('../HRStaffDetail')); // V70.62 — personel detayı portal içinde
const HREmployees = lazy(() => import('../HREmployees')); // V70.168 — Çalışanlar listesi (spec §3.1)
const HRSiteMap = lazy(() => import('../HRSiteMap')); // V70.179 — Site Haritası (spec Faz 0)
const HRPayrollSettings = lazy(() => import('../HRPayrollSettings')); // V70.182 — kesinti tanımları
const HRAuditLog = lazy(() => import('../HRAuditLog')); // V70.182 — Yönetim > Sistem > Audit Log
const HRAccess = lazy(() => import('../HRAccess')); // V70.194 — Faz 2 Kullanıcı & Yetki Yönetimi

const Loading = () => <div className="hr-app-loading">Yükleniyor…</div>;

// V71 — sayfa bazlı rota koruması HRLayout'ta (hrPageGroups.canSeeHRRoute): menüdeki kuralın
// aynısı her rotaya uygulanır. Personel detayı (/HR/staff/:id) Çalışanlar grubunun kuralını izler;
// eski HRStaffGuard'daki hr_performance/hr_panel anahtarları portal kapısını hiç açmadığından ölüydü.

export default function HRApp() {
  return (
    <HRLayout>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<HRDashboard />} />
          <Route path="self" element={<HRProfile />} />
          <Route path="team" element={<HRTeam />} />
          <Route path="leaves" element={<HRLeaves />} />
          <Route path="advances" element={<HRAdvances />} />
          <Route path="expenses" element={<HRExpenses />} />
          <Route path="trainings" element={<HRTrainings />} />
          <Route path="payslips" element={<HRPayslips />} />
          <Route path="documents" element={<HRComingSoon icon="📁" title="Belgelerim"
            description="Özlük belgelerinize (sözleşme, sertifika, kimlik fotokopisi vb.) bu bölümden erişebileceksiniz. Belgeleriniz şimdilik İK departmanında saklanıyor; süresi yaklaşan belgeleriniz Panel'de listelenir." />} />
          {/* V70.182 — şablon sekmesi Yönetim'e taşındı; burada takvim + toplu atama kalır */}
          <Route path="shifts" element={<HRShifts only={["calendar", "bulk"]} title="Vardiya" subtitle="Takvim ve toplu atama — şablonlar Yönetim > Çalışma Yönetimi Ayarları'nda" />} />
          <Route path="timesheet" element={<HRTimesheet />} />
          <Route path="overtime" element={<HROvertime />} />
          <Route path="compliance" element={<HRCompliance />} />
          <Route path="salary" element={<HRSalary />} />
          <Route path="payroll" element={<HRPayroll />} />
          <Route path="org-chart" element={<HROrgChart />} />
          <Route path="eval-cycles" element={<HREvalCycles />} />
          <Route path="eval-tasks" element={<HREvalMyTasks />} />
          <Route path="weekly-duty" element={<WeeklyDuty />} />
          <Route path="remote-work" element={<HRRemoteWork />} />
          <Route path="access" element={<HRAccess />} />
          <Route path="site-map" element={<HRSiteMap />} />
          {/* V70.182 — spec §3.2 TO-BE: tanım/kural/limit ekranları Yönetim altında. */}
          {/* Tanımlar sayfası birleştirilip dağıtıldı; eski adres ilk hedefe yönlenir. */}
          <Route path="definitions" element={<Navigate to="/HR/management/departments" replace />} />
          <Route path="management/departments" element={<HRDefinitions only={["departments"]} title="Departmanlar" subtitle="Organizasyon departman tanımları ve hiyerarşisi" />} />
          <Route path="management/positions" element={<HRDefinitions only={["positions"]} title="Pozisyonlar" subtitle="Pozisyon tanımları ve seviyeleri" />} />
          <Route path="management/leave-types" element={<HRDefinitions only={["types"]} title="İzin Türleri" subtitle="İzin tipleri ve yıllık hak tanımları" />} />
          <Route path="management/leave-balances" element={<HRDefinitions only={["balances"]} title="İzin Bakiyeleri" subtitle="Personel izin bakiyeleri ve toplu içe aktarma" />} />
          <Route path="management/limits" element={<HRDefinitions only={["limits"]} title="Avans & Harcama Limitleri" subtitle="Talep limitleri ve kuralları" />} />
          <Route path="management/ticket-rights" element={<HRDefinitions only={["biletler"]} title="Uçak Bileti Hakları" subtitle="Yan hak tanımları ve kıdem kuralları" />} />
          <Route path="management/shift-patterns" element={<HRShifts only={["patterns"]} title="Vardiya Şablonları" subtitle="Vardiya tanımları — atama ve takvim Mesai bölümünde" />} />
          <Route path="management/payroll-deductions" element={<HRPayrollSettings />} />
          <Route path="audit-log" element={<HRAuditLog />} />
          <Route path="employees" element={<HREmployees />} />
          <Route path="staff/:id" element={<HRStaffDetail />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Routes>
      </Suspense>
    </HRLayout>
  );
}
